module.exports = __webpack_public_path__ + "img/guy-01.2ac28b63.svg";